import React from "react";
import { IconClose, IconLock } from "@synthesis/shared-icons";
import { cn, getNoun } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/TableFiltersLine/local-components/FilterHint/FilterHint.tsx
const FilterHint = React.forwardRef(({ icon, label, onClose, value, disabled, inactive, onClick, className, ...other }, ref) => {
	const [valueWidth, setValueWidth] = React.useState(0);
	const checkValueLengthRef = React.useRef(null);
	const joinedValue = Array.isArray(value) ? value.join(",") : value;
	const normalizedValue = valueWidth > 280 && Array.isArray(value) && value.length > 1 ? `по ${value.length}-${getNoun(value.length, "м", "м", "и")} ${getNoun(value.length, "значению", "значениям", "значениям")}` : joinedValue;
	const leftIcon = icon ? /* @__PURE__ */ jsx("span", {
		className: "text-neutrals-60 block size-5 cursor-pointer transition-colors",
		children: icon
	}) : null;
	const rightIcon = inactive ? null : disabled ? /* @__PURE__ */ jsx(IconLock, { className: "text-neutrals-60 relative size-5 cursor-not-allowed before:absolute before:-left-1.5 before:-top-1.5 before:block before:h-9 before:w-9" }) : /* @__PURE__ */ jsx(IconClose, {
		className: "text-neutrals-60 relative size-5 cursor-pointer before:absolute before:-left-1.5 before:-top-1.5 before:block before:h-9 before:w-9",
		onClick: (ev) => {
			ev.preventDefault();
			ev.stopPropagation();
			onClose?.();
		}
	});
	React.useEffect(() => {
		setValueWidth(checkValueLengthRef.current?.offsetWidth ?? 0);
	}, [joinedValue]);
	return /* @__PURE__ */ jsxs("div", {
		className: cn("border-neutrals-90 relative inline-flex cursor-default items-center gap-2 rounded border px-1.5 py-1 transition-colors", "hover:bg-neutrals-95 active:border-neutrals-80 active:bg-neutrals-90", "focus:outline-additional-blue-50 focus:outline focus:outline-2", "data-[disabled=true]:border-neutrals-90 data-[disabled=true]:bg-neutrals-90 data-[disabled=true]:opacity-70", className),
		"data-disabled": disabled,
		ref,
		onClick: (ev) => {
			ev.stopPropagation();
			ev.preventDefault();
			onClick?.(ev);
		},
		...other,
		children: [
			/* @__PURE__ */ jsx("p", {
				ref: checkValueLengthRef,
				className: "absolute -left-56 -top-64 -z-50 whitespace-nowrap opacity-0",
				children: joinedValue
			}),
			leftIcon,
			/* @__PURE__ */ jsxs("p", {
				className: "subtitle-sm text-type-light flex items-center gap-1",
				children: [/* @__PURE__ */ jsx("span", {
					className: "max-w-48 truncate",
					children: label
				}), /* @__PURE__ */ jsx("span", {
					className: "text-type-minor max-w-72 truncate",
					children: normalizedValue
				})]
			}),
			rightIcon
		]
	});
});
FilterHint.displayName = "FilterHint";
//#endregion
export { FilterHint };

//# sourceMappingURL=FilterHint.js.map